module.exports = __webpack_public_path__ + "static/media/fyyf.5729e96b.png";